import React from 'react';
import SwitchDialogWindows from 'components/shared/SwitchDialogWindows';
import { eApplicationActions, IModalMessage, useApplicationContext } from 'state';
import { Grid } from 'ui-toolkit/components/Grid';
import { BodyText, BoldBodyText, Header3Text } from 'ui-toolkit/components/Typography/basicTypography';
import { SpruceHelpInlineLink } from 'ui-toolkit/components/Navigation/SpruceHelpInlineLink';
import { partiesActionsSlice } from '../../../../../../store/order/orderData/partiesActionsSlice';
import { useAppDispatch } from '../../../../../../store/store';

export interface IPartyModalMessagesProps extends IModalMessage {
  hasExtraSuccessWarning?: boolean;
  multipleThingsHaveBeenUpdated?: boolean;
}

export const PartyModalMessages: React.FC<IPartyModalMessagesProps> = ({
  verb,
  multipleThingsHaveBeenUpdated,
  ...props
}) => {
  const dispatchRedux = useAppDispatch();
  const [, dispatchContext] = useApplicationContext();
  const onCancelClick = () => {
    dispatchContext({ type: eApplicationActions.ClearPartyModalMessage });
    dispatchRedux(partiesActionsSlice.actions.reset({}));
  };
  const { updated, error, updating, hasExtraSuccessWarning } = props;
  const newProps = { updated, error, updating, onCancelClick };
  return (
    <SwitchDialogWindows
      {...newProps}
      successMessage={
        <SuccessMessage
          multipleThingsHaveBeenUpdated={multipleThingsHaveBeenUpdated}
          verb={verb}
          hasExtraSuccessWarning={hasExtraSuccessWarning}
        />
      }
      processingTitle={'Working...'}
      successTitle={''}
      errorTitle={<ErrorTitle verb={verb} />}
      defaultDialogComponent={<></>}
    />
  );
};

const SuccessMessage: React.FC<{
  multipleThingsHaveBeenUpdated?: boolean;
  verb: string;
  hasExtraSuccessWarning?: boolean;
}> = ({ multipleThingsHaveBeenUpdated, verb, hasExtraSuccessWarning }) => {
  return (
    <Grid alignItems={'center'} textAlign={'center'}>
      <Header3Text>{`${multipleThingsHaveBeenUpdated ? 'Parties have been' : 'Party has been'} ${verb}!`}</Header3Text>
      {hasExtraSuccessWarning && (
        <div>
          <BodyText>Documents have regenerated.</BodyText>
          <BoldBodyText>Note: A new title search may be required.</BoldBodyText>
        </div>
      )}
    </Grid>
  );
};

const ErrorTitle: React.FC<{ verb: string }> = ({ verb }) => {
  return (
    <Header3Text>
      Party was not {verb}. Please <SpruceHelpInlineLink /> to submit a request for help.
    </Header3Text>
  );
};
